import { getSessionInfo } from '@shipt/analytics-member-web'
import { setCookie, removeCookie, getCookie } from '@/features/shared/utils/cookies'
import { isOnServer } from '@shared/constants/util'
import { type MarvAdviceByCampaign } from '@/features/shared/utils/dataFetching'
import { type Query } from '@tanstack/react-query'
import { isObject } from '@/features/shared/utils/isObject'

export const MARV_ADVICE_BY_CAMPAIGN = 'marv_advice_by_campaign'

const isMarvAdviceByCampaign = (data: unknown): data is MarvAdviceByCampaign =>
  Boolean(data && isObject(data) && 'marv_advice_by_campaign' in data)

export const handleMarvAdviceCookieForQueryOnSuccess = (query: Query) => {
  const data = query.state.data

  if (isMarvAdviceByCampaign(data) && data.marv_advice_by_campaign) {
    let marvAdviceObj = { ...data.marv_advice_by_campaign }
    const existingCookie = getCookie(MARV_ADVICE_BY_CAMPAIGN) ?? {}
    if (
      query.meta?.marvUpdateBehavior === 'append' &&
      existingCookie &&
      typeof existingCookie === 'object'
    ) {
      marvAdviceObj = {
        ...marvAdviceObj,
        ...existingCookie,
      }
    }
    setCookie(MARV_ADVICE_BY_CAMPAIGN, marvAdviceObj, { expires: 365 }) // 1 year, in days
  }
}

export const handleMarvAdviceCookieExpiration = () => {
  if (isOnServer()) return
  // we need to clear the MARV_ADVICE_BY_CAMPAIGN cookie's value if the user's session
  // is expired to ensure we don't send stale marv advice values in tracking events
  if (getSessionInfo().isSessionExpired) removeCookie(MARV_ADVICE_BY_CAMPAIGN)
}
